import React from "react";
import TranslationsContext from "../../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../../infrastructure/translation-manager";
import ITranslationsContext from "../../../infrastructure/context/translations/translations-context.interface";
import {
  TranslationKeys,
} from "../../../infrastructure/const";
import Spinner from "../../common/spinner";
import {
  MandatoryCheckboxesRefs,
} from "../../common/mandatory-checkboxes/mandatory-checkboxes-section";
import TermsAndConditionsCheckboxes from "../common/terms-and-conditions-checkboxes";

type CheckoutSummaryProps = {
  onContinueClick: (
    checkboxesSelected: Array<string>,
    areAllMandatoryCheckboxesSelected: boolean
  ) => void;
  isLoaded: boolean;
  displayValidationMessages: boolean;
};

type CheckoutSummaryState = {
  goToCheckoutClicked: boolean;
};

export default class CheckoutFreeSummary extends React.Component<
  CheckoutSummaryProps,
  CheckoutSummaryState
> {
  private TranslationManager: TranslationManager;
  private translations: { [id: string]: string };
  private checkboxesRef: React.RefObject<MandatoryCheckboxesRefs>;

  constructor(props: CheckoutSummaryProps, context: ITranslationsContext) {
    super(props, context);
    this.state = {
      goToCheckoutClicked: false,
    } as CheckoutSummaryState;

    this.TranslationManager = new TranslationManager(this.context);

    this.translations = {
      continue: this.TranslationManager.getTranslation(
        TranslationKeys.CONTINUE
      ),
      orderSummary: this.TranslationManager.getTranslation(
        TranslationKeys.CART_ORDERSUMMARY_HEADER
      ),
    };

    this.checkboxesRef = React.createRef<MandatoryCheckboxesRefs>();
  }

  onContinueClick(): void {
    let selectedCheckboxes: Array<string>;
    let areAllCheckboxesSelected: boolean;

    if (
      this.checkboxesRef !== undefined &&
      this.checkboxesRef !== null &&
      this.checkboxesRef.current !== null &&
      this.checkboxesRef.current !== undefined
    ) {
      selectedCheckboxes =
        this.checkboxesRef.current.getSelectedCheckboxesList();
      areAllCheckboxesSelected =
        this.checkboxesRef.current.allCheckboxesSelected();

      this.props.onContinueClick(selectedCheckboxes, areAllCheckboxesSelected);
    }
  }

  render(): JSX.Element {
    return (
      <li id="opc-review">
        <div id="checkout-step-review" className="checkout-step">
          <div className="checkout-step__title">
            <span className="text">{this.translations.orderSummary}</span>
          </div>
          <div className="content-container">
            {this.props.isLoaded ? (
              <div className="checkout-final">
                <div id="checkout-review-load" className="default-box">
                  <TermsAndConditionsCheckboxes
                    displayValidationMessages={
                      this.props.displayValidationMessages
                    }
                    checkboxesRef={this.checkboxesRef}
                  />
                </div>

                <div className="content button-set">
                  <span id="review-buttons-container">
                    <button
                      id="place-order-button"
                      className="button-addToCart"
                      type="button"
                      onClick={() => this.onContinueClick()}
                    >
                      {this.translations.continue}
                    </button>
                  </span>
                </div>
              </div>
            ) : (
              <Spinner show />
            )}
          </div>
        </div>
      </li>
    );
  }
}

CheckoutFreeSummary.contextType = TranslationsContext;
